// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"186":"2db96cd0","997":"0fb5cf95"}[chunkId] + ".chunk.js");